export const info = count => {
  const currentDate = new Date()
  const options_date = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  const _options_fulltime = {
    timeZone: 'America/Guayaquil',
    hour12: false,
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
  }
  const dateLocate = currentDate.toLocaleDateString('es-ec', options_date)
  const formatFullTime = currentDate.toLocaleTimeString('es-ec', _options_fulltime)
  const date = `${dateLocate} (${formatFullTime})`
  return [
    {
      col1: 'Proyecto de investigación:  17-DI-FARNR-2021: “Dinámica de crecimiento y servicios ecosistémicos del arbolado urbano de la ciudad de Loja” ',
    },
    {
      col1: '',
    },
    {
      col1: '',
    },
    {
      col1: 'Cita para la base de datos:',
    },
    {
      col1: 'Pucha-Cofrep, D. A., Lozano, D. ., Jumbo, N., Fernández, P., Armijos, A., Macas, M. F., Gualán, R., Merino, B. (2023). Base de datos del inventario del arbolado urbano de la ciudad de Loja. https://arbolqr.unl.edu.ec/informacion',
    },
    {
      col1: '',
    },
    {
      col1: 'Cita del artículo principal:',
    },
    {
      col1: `Pucha-Cofrep, D. A., Lozano, D. ., Jumbo, N., Fernández, P., Armijos, A., Macas, M. F., Gualán, R., Merino, B. (2023). Caracterización florística y estructura del arbolado urbano de la ciudad de Loja. Bosques Latitud Cero, 13(2), 1–22. https://doi.org/10.54753/blc.v13i2.1886`,
    },
    {
      col1: '',
    },
    {
      col1: 'Correspondencia: darwin.pucha@unl.edu.ec',
    },
    {
      col1: '',
    },
    {
      col1: '',
    },
    {
      col1: 'NOTA',
    },
    {
      col1: 'Si desea utilizar esta base de datos del inventario del arbolado urbano de la ciudad de Loja, le solicitamos por favor:',
    },
    {
      col1: '1. Notifique al autor de correspondencia (Darwin Pucha-Cofrep) si planea utilizar la base de datos en una publicación.',
    },
    {
      col1: '2. Reconozca los esfuerzos de este grupo en la recopilación de los datos utilizando la cita para la base de datos mencionada anteriormente.',
    },
    {
      col1: '3. Reconozca que estos datos fueron recopilados por el grupo para diversos análisis e interrogantes de la propia investigación.',
    },
    {
      col1: '',
    },
    {
      col1: '',
    },
    {
      col1: '',
    },
    {
      col1: `Nro. Registros: ${count}`,
    },
    {
      col1: `Fecha de descarga: ${date}`,
    },
  ]
}

export const widthCol = [
  { wch: 13 },
  { wch: 23 },
  { wch: 13 },
  { wch: 23 },
  { wch: 26 },
  { wch: 12 },
  { wch: 30 },
  { wch: 12 },
  { wch: 11 },
  { wch: 11 },
  { wch: 14 },
  { wch: 15 },
  { wch: 16 },
  { wch: 14 },
  { wch: 15 },
  { wch: 20 },
  { wch: 22 },
  { wch: 17 },
  { wch: 18 },
  { wch: 20 },
  { wch: 38 },
  { wch: 23 },
]
